import { forwardRef, useEffect } from "react";
import { useFetchUser } from "../hooks/fetch/useFetchUsers";
import useStore from "../hooks/useStore";
import RadioFormInputs from "./radioFormInputs";

const PeriodOverride = forwardRef(function PeriodOverride(
  { id, disabled, value, onChange, onBlur },
  ref,
) {
  const { value: period, userId, unit } = value || {};
  const clientRef = useStore((state) => state.clientRef);

  const { data: user } = useFetchUser({
    account: clientRef,
    userId,
  });

  const defaultUnit =
    user?.employment?.calcDaysHours ||
    (user?.employment?.type === "Part time" ? "hours" : "days");
  const selectedUnit = unit || defaultUnit;

  // Persist the employee's default for new and legacy absences once loaded.
  useEffect(() => {
    if (!unit && user && onChange) {
      onChange({ ...value, unit: defaultUnit });
    }
  }, [unit, user, defaultUnit, value, onChange]);

  return (
    <>
      <label htmlFor={id}>Allocate a specific period to this absence</label>
      <input
        ref={ref}
        id={id}
        type="number"
        min="0"
        step={0.1}
        disabled={disabled}
        value={period ?? ""}
        onBlur={onBlur}
        onChange={(e) => onChange({ ...value, value: e.target.value })}
      />
      <div role="group" aria-label="Period unit">
        <RadioFormInputs
          name={`${id}-unit`}
          label="Period unit"
          value={selectedUnit}
          options={[
            { label: "Days", value: "days" },
            { label: "Hours", value: "hours" },
          ]}
          disabled={disabled || (!unit && !user)}
          register={() => ({ onBlur })}
          validation={() => ({})}
          onChange={(_event, unit) => onChange({ ...value, unit })}
        />
      </div>
    </>
  );
});

export default PeriodOverride;
